import { ImageObfuscation, TaggedImage, TaggedImageResult } from "constructs/TaggedImage";


export function transformImageResult(result: Array<TaggedImageResult>): Array<TaggedImage> {
  const images: Array<TaggedImage> = result.map((imageResult, index) => {
    const imageObf: Array<ImageObfuscation> = imageResult.obfuscations ? JSON.parse(imageResult.obfuscations) : [];
    const imageStyles: Record<string, any> = imageResult.styles ? JSON.parse(imageResult.styles) : {};

    return {
      ...imageResult,
      obfuscations: imageObf,
      styles: imageStyles,
    };
  })
  
  return images;
}